export const adminSessionQueryKey = ['admin', 'session'] as const

export function safeAdminReturnTo(value: string | null | undefined): string {
  if (
    value &&
    /^\/admin(?:\/|$)/.test(value) &&
    !value.startsWith('//') &&
    !value.startsWith('/admin/entrar')
  ) {
    return value
  }
  return '/admin/momentos'
}
